var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#303030", fillRule: "evenodd", d: "M4 6v14l2.707-2.707A1 1 0 0 1 7.414 17H18a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2zM3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3H7.414l-2.707 2.707C4.077 21.337 3 20.891 3 20V6zm6.726 8.005a.182.182 0 0 1-.265-.192l.434-2.533-1.84-1.793a.182.182 0 0 1 .101-.312l2.543-.37 1.137-2.303a.182.182 0 0 1 .328 0L13.3 8.806l2.543.37c.15.021.209.205.1.31l-1.84 1.794.435 2.533a.182.182 0 0 1-.265.192L12 12.809l-2.274 1.196z" })
  );
});